export default __webpack_public_path__ + "static/media/icon-edit.60b7c1fc.svg";